// extracted by mini-css-extract-plugin
module.exports = {"contacts__container":"page_contacts__container__oG7WB","contacts__link":"page_contacts__link__qU9RP","main__page":"page_main__page__Vxe_b"};